import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { postData } from "../../../service/Service";

const initialState = {
  data: {
    dashboard: [],
    dashboardFarmer: []
  },
  updatedTime: 0,
  isLoading: false,
  isError: "",
  message: "",
  postMessage: "",
  postStatus: "",
  deleteMessage: "",
  deleteStatus: "",
  updateMessage: "",
  updateStatus: "",
};

export const getReportHarvestEstimate = createAsyncThunk(
  "farmer/report/harvest-estimate",
  async (data, { rejectWithValue }) => {
    try {
      const result = await postData(
        "/farmer/harvest-estimate/report",
        data.token,
        data.data
      );
      return result.data;
    } catch (err) {
      return rejectWithValue(err.response.data);
    }
  }
);

export const getReportHarvestEstimateFarmer = createAsyncThunk(
  "farmer/harvest-estimate/report/farmer",
  async (data, { rejectWithValue }) => {
    try {
      const result = await postData(
        "/farmer/harvest-estimate/report/farmer",
        data.token,
        data.data
      );
      return result.data;
    } catch (err) {
      return rejectWithValue(err.response.data);
    }
  }
);


const reportHarvestEstimate = createSlice({
  name: "Report Harvest Estimate",
  initialState: initialState,
  extraReducers: {
    [getReportHarvestEstimate.pending]: (state) => {
      state.isLoading = true;
    },
    [getReportHarvestEstimate.fulfilled]: (state, action) => {
      state.data.dashboard = action.payload.data;
      state.isError = false;
      state.isLoading = false;
      state.updatedTime = Date.now();
      state.message = action.payload.message;
    },
    [getReportHarvestEstimate.rejected]: (state, action) => {
      state.isError = true;
      state.isLoading = false;
      state.message = action.payload.message;
    },
    [getReportHarvestEstimateFarmer.pending]: (state) => {
      state.isLoading = true;
    },
    [getReportHarvestEstimateFarmer.fulfilled]: (state, action) => {
      state.data.dashboardFarmer = action.payload.data;
      state.isError = false;
      state.isLoading = false;
      state.updatedTime = Date.now();
      state.message = action.payload.message;
    },
    [getReportHarvestEstimateFarmer.rejected]: (state, action) => {
      state.isError = true;
      state.isLoading = false;
      state.message = action.payload.message;
    },
  },
});

export const reportHarvestEstimateActions = reportHarvestEstimate.actions;

export default reportHarvestEstimate.reducer;
